import { Grid, Stack, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'

import {
  Product as ProductType,
  Showcase as ShowcaseType,
  Site as SiteType,
  Store as StoreType
} from '@/types'

import ProductCard from './ProductCard'

interface Props {
  site?: SiteType
  store?: StoreType
  showcase?: ShowcaseType
  products: ProductType[]
}

export default function SinglePageDisplay({ site, store, showcase, products }: Props) {
  // Hooks
  const theme = useMantineTheme()
  const isSm = useMediaQuery(`(max-width: ${theme.breakpoints.sm}px)`)

  // Constants
  const showListMode = products?.length <= 4 && !isSm
  const gridSizes = showListMode
    ? { span: 12, md: products?.length === 1 ? 12 : 6 }
    : { span: 12, xs: 6, md: 4, lg: 12 / 5 }

  return (
    <Stack>
      {Array.isArray(products) && !!products?.length && (
        <Grid gutter="lg">
          {products.map((product: any) => (
            <Grid.Col key={product?.uid} {...gridSizes}>
              <ProductCard
                product={product}
                site={site}
                store={store}
                showcase={showcase}
                showListMode={showListMode}
              />
            </Grid.Col>
          ))}
        </Grid>
      )}
    </Stack>
  )
}
